import { render, staticRenderFns } from "./ArtistCompareList.vue?vue&type=template&id=2319c25a&scoped=true"
import script from "./ArtistCompareList.vue?vue&type=script&lang=js"
export * from "./ArtistCompareList.vue?vue&type=script&lang=js"
import style0 from "./ArtistCompareList.vue?vue&type=style&index=0&id=2319c25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2319c25a",
  null
  
)

export default component.exports